<template>
    <div class="rule">
      <img src="../assets/image/bg6.jpg" alt="">
    </div>
</template>

<script>
    export default {
        name: "rule"
    }
</script>

<style scoped>
.rule{
  width: 1136px;
  margin: 50px auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/rule.vue